/* Packeta — výber výdajného miesta v košíku.
   Widget sa načíta až na kliknutie, aby košík nespomaľoval. */
(function () {
  'use strict';

  var koren = document.querySelector('[data-packeta]');
  if (!koren) return;

  var LIBRARY = 'https://widget.packeta.com/v6/www/js/library.js';

  var kurier = koren.querySelector('[data-packeta-volba="kurier"]');
  var packeta = koren.querySelector('[data-packeta-volba="packeta"]');
  var panel = koren.querySelector('[data-packeta-panel]');
  var miesto = koren.querySelector('[data-packeta-miesto]');
  var otvorit = koren.querySelector('[data-packeta-otvorit]');
  var hlaska = koren.querySelector('[data-packeta-hlaska]');
  var poleText = koren.querySelector('[data-packeta-pole-text]');
  var poleJson = koren.querySelector('[data-packeta-pole-json]');
  var tlacidlo = document.querySelector('.cart-summary [name="checkout"]');

  var hmotnost = parseFloat(koren.getAttribute('data-hmotnost')) || 0;
  var nacitava = null;

  /* ---- pomocníky ---- */

  function vybraneMiesto() {
    var surove = poleJson.value;
    if (!surove) return null;
    try { return JSON.parse(surove); } catch (e) { return null; }
  }

  function popis(bod) {
    return [bod.place || bod.name, bod.street, [bod.zip, bod.city].filter(Boolean).join(' ')]
      .filter(Boolean).join(', ');
  }

  function prekresli() {
    var jePacketa = packeta.checked;
    var bod = vybraneMiesto();

    panel.hidden = !jePacketa;
    miesto.hidden = !bod;
    if (bod) {
      miesto.textContent = popis(bod);
      otvorit.textContent = 'Zmeniť výdajné miesto';
    } else {
      otvorit.textContent = 'Vybrať výdajné miesto';
    }

    if (!tlacidlo) return;
    if (jePacketa && !bod) {
      tlacidlo.disabled = true;
      hlaska.textContent = 'Najprv vyber výdajné miesto.';
    } else {
      tlacidlo.disabled = false;
      hlaska.textContent = '';
    }
  }

  function uloz(bod) {
    var atributy = {};
    atributy['Výdajné miesto'] = bod ? popis(bod) : '';
    atributy['_packeta_point'] = bod ? JSON.stringify(bod) : '';

    poleText.value = atributy['Výdajné miesto'];
    poleJson.value = atributy['_packeta_point'];
    prekresli();

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: atributy })
    }).catch(function () {
      /* Sieť zlyhala — skryté polia sa odošlú s formulárom košíka. */
      hlaska.textContent = 'Výber sa neuložil na server, ale odošle sa s objednávkou.';
    });
  }

  function nacitajKniznicu() {
    if (window.Packeta && window.Packeta.Widget) return Promise.resolve();
    if (nacitava) return nacitava;

    nacitava = new Promise(function (splnene, zlyhalo) {
      var s = document.createElement('script');
      s.src = LIBRARY;
      s.onload = splnene;
      s.onerror = function () { zlyhalo(new Error('library.js sa nenačítal')); };
      document.head.appendChild(s);
    });
    return nacitava;
  }

  function vendori() {
    var krajiny = (koren.getAttribute('data-krajiny') || 'sk')
      .split(',').map(function (k) { return k.trim().toLowerCase(); })
      .filter(Boolean);
    var zoznam = [];
    krajiny.forEach(function (krajina) {
      if (koren.getAttribute('data-zbox') === 'true') {
        zoznam.push({ country: krajina, group: 'zbox' });
      }
      if (koren.getAttribute('data-zpoint') === 'true') {
        zoznam.push({ country: krajina });
      }
    });
    return zoznam;
  }

  /* ---- obsluha ---- */

  function otvorWidget() {
    hlaska.textContent = 'Načítavam mapu…';

    nacitajKniznicu().then(function () {
      hlaska.textContent = '';
      window.Packeta.Widget.pick(
        koren.getAttribute('data-api-kluc'),
        function (bod) {
          if (!bod) return;                  /* zákazník zrušil výber */
          uloz({
            id: bod.id,
            name: bod.name,
            place: bod.place,
            street: bod.street,
            city: bod.city,
            zip: bod.zip,
            country: bod.country,
            group: bod.group,
            pickupPointType: bod.pickupPointType,
            maxWeight: bod.maxWeight
          });
        },
        {
          language: 'sk',
          country: koren.getAttribute('data-krajiny') || 'sk',
          vendors: vendori(),
          weight: hmotnost,
          webUrl: 'https://respiratorshop.sk',
          appIdentity: 'shopify-respiratorshop-packeta-1.0'
        }
      );
    }).catch(function () {
      hlaska.textContent = 'Mapu výdajných miest sa nepodarilo načítať. '
        + 'Skús to znova, alebo zvoľ doručenie kuriérom.';
    });
  }

  otvorit.addEventListener('click', otvorWidget);
  kurier.addEventListener('change', function () {
    if (kurier.checked && vybraneMiesto()) uloz(null);
    prekresli();
  });
  packeta.addEventListener('change', function () {
    prekresli();
    if (!vybraneMiesto()) otvorWidget();
  });

  /* Košík mohol medzitým oťažieť — vybrané miesto už nemusí stačiť. */
  var bod = vybraneMiesto();
  if (bod && bod.maxWeight && hmotnost > parseFloat(bod.maxWeight)) {
    uloz(null);
    kurier.checked = true;
    hlaska.textContent = 'Objednávka oťažela a vybrané miesto ju už neprijme. '
      + 'Vyber prosím iné.';
  }

  prekresli();
})();
